import { Checkbox } from '@mantine/core';
import { categories, type CategoryId } from '@shared/config/categories';
import classes from './game-category-picker.module.css';

type Props = {
  selected: readonly CategoryId[];
  available: readonly CategoryId[];
  onToggle: (id: CategoryId) => void;
  disabled?: boolean;
};

export const GameCategoryPicker = ({ selected, available, onToggle, disabled }: Props) => (
  <fieldset className={classes.root} disabled={disabled}>
    <legend>Что будем угадывать?</legend>
    <div className={classes.options}>
      {categories
        .filter((category) => available.includes(category.id))
        .map((category) => (
          <Checkbox.Card
            key={category.id}
            className={classes.option}
            checked={selected.includes(category.id)}
            disabled={disabled}
            onChange={() => onToggle(category.id)}
            aria-label={category.label}
          >
            <img src={category.image} alt="" />
            <span>{category.label}</span>
            <Checkbox.Indicator />
          </Checkbox.Card>
        ))}
    </div>
  </fieldset>
);
